import type { FeatureFlags } from '@noths/polaris-client-feature-flags';
import type { DeliveryZoneCode } from '@noths/polaris-client-localisation';
import type { CurrencyCode } from '@noths/polaris-dev-ts-types';
import { createSlice } from '@reduxjs/toolkit';

export type CookieConsent = {
  analyticalExperienceCookiesConsented?: boolean;
  functionalCookiesConsented?: boolean;
  performanceCookiesConsented?: boolean;
  targetingAdvertisingCookiesConsented?: boolean;
  technicalCookiesConsented?: boolean;
};

export interface UserState {
  bot?: boolean; // true if the user is a bot
  cognitoID: string | null;
  cookieConsent?: CookieConsent;
  countryCode: string;
  currencyCode: CurrencyCode;
  deliveryZone?: DeliveryZoneCode;
  featureFlags?: FeatureFlags;
  gaVisitorId?: string;
}

const initialState: UserState = {
  cognitoID: null,
  countryCode: 'GB',
  currencyCode: 'GBP',
};

export const { actions, reducer } = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setDeliveryZone: (state, { payload }) => {
      if (payload) {
        state.deliveryZone = payload;
      }
    },
    setCookieConsent: (state, { payload }) => {
      if (payload) {
        state.cookieConsent = payload;
      }
    },
    setFeatureFlags: (state, { payload }) => {
      if (payload) {
        state.featureFlags = payload;
      }
    },
  },
});
